import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { StatusHistoryBestfitOriginEnum, StatusHistoryChainModel, StatusHistoryOriginEnum } from '../../common/models';
import { LOCALE_DEFAULT_FORMAT, StatusHistoryConditionType, IconNames, SCode } from '../../common/constants';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { DateWithProfileAndLocalTimezoneComponent } from '../profile-and-local-date/date-with-profile-and-local-timezone.component';

export const StatusHistoryBestfitOriginDisplayMap: Record<StatusHistoryBestfitOriginEnum, string> = {
  [StatusHistoryBestfitOriginEnum.LSP]: 'LSP',
  [StatusHistoryBestfitOriginEnum.ML]: 'ML',
  [StatusHistoryBestfitOriginEnum.SG]: 'SG',
};

@Component({
  selector: 'ui-status-history-chain',
  imports: [
    CommonModule,
    IntrackFeatureModule,
    TranslateModule,
    SvgIconComponent,
    DateWithProfileAndLocalTimezoneComponent,
  ],
  templateUrl: './status-history-chain.component.html',
  styleUrls: ['./status-history-chain.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusHistoryChainComponent {
  @Input() historyStatuses: StatusHistoryChainModel[] = [];
  @Input() hasPredictedDateTime = false;

  protected readonly bestfitOriginDisplayMap = StatusHistoryBestfitOriginDisplayMap;
  statusHistoryOrigin = StatusHistoryOriginEnum;
  dateFormat = LOCALE_DEFAULT_FORMAT;
  iconNames = IconNames;
  statusCodes = SCode;
  betaFlag = 'beta';
  conditionClassMap = {
    [StatusHistoryConditionType.Actual]: 'actual',
    [StatusHistoryConditionType.NotProvided]: 'not-provided',
    [StatusHistoryConditionType.Estimated]: 'estimated',
    [StatusHistoryConditionType.NotExpected]: 'not-expected',
  };
}
